import { Divider } from '@mui/material'
import Form from '../../../components/Form'
import { useForm } from 'react-hook-form'
import FormItem from '../../../components/Form/FormItem'
import SelectOfCategories from '../../../components/Inputs/SelectOfCategories'
import InputNumber from '../../../components/Inputs/InputNumber'
import Button from '../../../components/General/Button'
import React, { useEffect, useState } from 'react'
import InputText from '../../../components/Inputs/InputText'
import { formatPipe } from '../../../utils/utils'
import { useSelector } from 'react-redux'
import { RootState } from '../../../redux/store'
import CurrencyInput from '../../../components/Inputs/CurrencyInput'

interface ICardForm {
  onSubmitProp: Function
  onCancel: Function
  total: number
  debt: number | string
}

interface options {
  value: string
  text: string
}

export const CardForm: React.FC<ICardForm> = ({ onCancel, onSubmitProp, total, debt }) => {
  const form = useForm()

  const [listOfCards, setListOfCards] = useState<any>([])

  const accounts = useSelector(
    (state: RootState) => state.acct.accounts
  )

  const onSubmit = (values): void => {
    if (listOfCards.length === 0) {
      form?.setError('type', {
        type: 'manual',
        message: 'No hay opciones disponibles',
      })
      return
    }

    onSubmitProp({...values, amount: formatPipe(values.amount, true)})
  }

  const onGetAccountsCardsFormatter = (): options[] => {
    return accounts.reduce((a, b) => {
      if (b.cardSwiperNumber !== '') {
        return [...a, { text: b.description, value: b.id } as options]
      }
      return a as options[]
    }, [] as options[])
  }

  useEffect(() => {
    setListOfCards(onGetAccountsCardsFormatter())
    form.setValue('amount', `Bs. ${formatPipe(debt+"")}`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  return (
    <div>
      <label className="text-primary font-semibold mb-2">Tarjeta</label>
{/* 
      <Divider />

      <div className="flex flex-row justify-between mt-2">
        <label>DEUDA</label>
        <label>Bs. 66,79</label>
      </div>

      <div className="flex flex-row justify-between mb-2">
        <label>DEUDA EN USD: (REF)</label>
        <label>$ 1,00</label>
      </div> */}

      <Divider />

      <Form
        classes="gap-x-6 mt-4"
        form={form}
        onSubmit={(values) => {
          onSubmit(values)
          console.log('VALUES', values)
        }}
      >
        <FormItem
          name="amount"
          classes="col-span-12"
          defaultValue={''}
          rules={{
            required: 'Es necesario el monto',
            // pattern: { value: /^\d+(\.\d{2})?$/, message: 'Monto inválido' },
          }}
        >
          {/* <InputText small maxLength={80} /> */}
          {/* <InputNumber addDecimals={true} label='Monto' /> */}
          <CurrencyInput addDecimals={true} mask={'Bs. num'} label='Monto' />
        </FormItem>


        {/* <FormItem
          name="name"
          classes="col-span-12"
          rules={{ required: 'Es necesario un nombre' }}
        >
          <InputText label="Referencia" />
        </FormItem> */}

        <div className="col-span-12 flex mt-4">
        <Button type="outline" classes="w-1/2 mr-5" onClick={() => onCancel()}>
              Cancelar
            </Button>

          <Button type="primary" classes="w-1/2" htmlType="submit">
            Continuar
          </Button>
        </div>
      </Form>
    </div>
  )
}